import { connect } from 'react-redux';
import React from 'react';
import {
KBFormError,
KBButton } from
'components';
import { Field, reduxForm } from 'redux-form';
import { Select } from 'antd';
import * as valid from 'utils/validate';

var GroupSetPreview = class extends React.Component {constructor(props) {super(props);this.updateSpace = this.updateSpace.bind(this);this.renderEmails = this.renderEmails.bind(this);}
  updateSpace(

  model) {
    const { updateLocationSetting } = this.props;
    return updateLocationSetting(
    {
      sales_lead_settings: model },

    { key: 'sales_lead_settings' });

  }renderEmails(

  { input, meta }) {
    return (
      <div>
        <Select
        mode="tags"
        showSearch
        style={{ width: '100%' }}
        onChange={input.onChange}
        value={input.value || []}>

        </Select>
        {meta.touched && meta.error && <p className="lr-error">{meta.error}</p>}
      </div>);

  }render()

  {
    const { handleSubmit, setting, submitting } =
    this.props;
    if (!setting) {
      return null;
    }

    return (
      <div className="nav-section-content-container" style={{ padding: 0 }}>
        <header className="nav-header">
          <div className="nav-section-header-title">
            <span>预约参观设置</span>
          </div>
        </header>
        <div className="kb-form-container">
          <form onSubmit={handleSubmit(this.updateSpace)}>
            <KBFormError error={this.props.error} />
            <div className="kb-form-container" style={{ padding: 0 }}>
              <fieldset className="fieldset">
                <legend style={{ position: 'relative' }}><span className="must-fill">*</span>邮件发送列表</legend>
                <Field name="emails" component={this.renderEmails} />

              </fieldset>

              <div className="kb-row m-top">
                <KBButton
                className="certain-btn"
                type="submit"
                submitting={submitting}>

                  保存
                </KBButton>
              </div>
            </div>
          </form>
        </div>
      </div>);

  }};


function mapStateToProps(state, props) {
  const { groupSetting } = state;
  let setting_value = groupSetting.sales_lead_settings;
  return {
    initialValues: {
      ...setting_value } };


}

const validate = values => {
  const errors = {};

  if (!values.emails || values.emails.length === 0) {
    errors.emails = '请输入邮件发送列表';
  }

  const allAreEmail = (values.emails || []).every(i => !valid.email(i));
  if (!allAreEmail) {
    errors.emails = '请验证输入的邮箱';
  }

  return errors;
};

const formConfig = {
  form: 'GroupSetPreview',
  validate: validate,
  touchOnBlur: false,
  enableReinitialize: true };

GroupSetPreview = reduxForm(formConfig)(GroupSetPreview);

export default connect(mapStateToProps)(GroupSetPreview);
